import { Currency } from '@sequencehq/api'
import type { Dashboardv99990101CommonModels } from '@sequencehq/api/dashboard/v99990101'

type CreditNoteLineItemRateDisplay =
  Dashboardv99990101CommonModels.CreditNoteLineItems.CreditNoteLineItemRateDisplay
import { useCreateCreditNoteLineItem } from 'CreditNotes/hooks/useCreateCreditNoteLineItem'
import {
  BaseCreditNoteLineItemDrawer,
  FormValues,
  SubmitValues
} from './BaseCreditNoteLineItemDrawer'
import { useCreditNoteDefaultServicePeriod } from 'CreditNotes/hooks/useCreditNoteRevRec'

const initialValues: FormValues = {
  title: '',
  description: '',
  rateDisplay: 'ABSOLUTE' as CreditNoteLineItemRateDisplay,
  quantity: '1',
  amount: '',
  tax: '',
  taxCategoryId: '',
  servicePeriod: undefined,
  // New line items default to straight-line recognition — the most common
  // method for credited revenue — so users aren't forced to pick one manually
  revenueRecognitionMethod: 'STRAIGHT_LINE',
  productId: undefined
}

interface Props {
  creditNoteId: string
  groupId: string
  isOpen: boolean
  onClose: () => void
  creditNoteCurrency: Currency
}

const CreateCreditNoteLineItemDrawer = ({
  creditNoteId,
  groupId,
  isOpen,
  onClose,
  creditNoteCurrency
}: Props) => {
  const createCreditNoteLineItem = useCreateCreditNoteLineItem({
    creditNoteId,
    groupId
  })

  const defaultServicePeriod = useCreditNoteDefaultServicePeriod(creditNoteId)

  const handleSubmit = (formValues: SubmitValues): Promise<boolean> => {
    return createCreditNoteLineItem({
      title: formValues.title,
      description: formValues.description,
      rateDisplay: formValues.rateDisplay,
      quantity: formValues.quantity,
      rate: formValues.rate,
      taxRate: formValues.taxRate,
      servicePeriod: formValues.servicePeriod,
      revenueRecognitionMethod: formValues.revenueRecognitionMethod,
      productId: formValues.productId,
      taxCategoryId: formValues.taxCategoryId || undefined
    })
  }

  return (
    <BaseCreditNoteLineItemDrawer
      initialValues={{
        ...initialValues,
        servicePeriod: defaultServicePeriod
      }}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      creditNoteCurrency={creditNoteCurrency}
      title="Add line item"
      submitButtonText="Add"
    />
  )
}

export default CreateCreditNoteLineItemDrawer
